import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/image/time.png';
import _imports_1 from '../../assets/image/customer.png';
import _imports_2 from '../../assets/image/employee.png';
const _hoisted_1 = { class: "about" };
const _hoisted_2 = { class: "info-container max-width" };
const _hoisted_3 = { class: "content" };
const _hoisted_4 = { class: "text" };
const _hoisted_5 = { class: "image" };
const _hoisted_6 = ["src"];
const _hoisted_7 = { class: "stats" };
const _hoisted_8 = { class: "container max-width" };
const _hoisted_9 = { class: "item" };
const _hoisted_10 = { class: "content" };
const _hoisted_11 = { class: "number-content" };
const _hoisted_12 = { class: "number" };
const _hoisted_13 = { class: "item" };
const _hoisted_14 = { class: "content" };
const _hoisted_15 = { class: "number-content" };
const _hoisted_16 = { class: "number" };
const _hoisted_17 = { class: "item" };
const _hoisted_18 = { class: "content" };
const _hoisted_19 = { class: "number-content" };
const _hoisted_20 = { class: "number" };
import { ref, onMounted } from "vue";
import post from "./components/post.vue";
import { getAboutInfo } from "@/api/about";
import aboutImg from "@/assets/image/about.png";
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const postRef = ref();
        const clickCount = ref(0);
        const aboutData = ref({});
        const refreshData = async () => {
            try {
                const res = await getAboutInfo();
                aboutData.value = res.data;
            }
            catch {
                // 暂无数据
            }
        };
        onMounted(() => {
            refreshData();
        });
        const handleEdit = () => {
            const token = localStorage.getItem("token");
            if (!token) {
                return;
            }
            clickCount.value++;
            if (clickCount.value >= 2) {
                postRef.value.show(aboutData.value);
                clickCount.value = 0;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("section", {
                    class: "top-container",
                    onClick: handleEdit
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[0] || (_cache[0] = _createElementVNode("p", { class: "en-title" }, "ABOUT AIBU", -1)),
                            _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "cn-title" }, "关于爱布软件", -1)),
                            _createElementVNode("div", _hoisted_4, _toDisplayString(aboutData.value.companyContent || '王守仁，汉族，幼名云，字伯安，号阳明...'), 1),
                            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "btn" }, "公司介绍 →", -1))
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("img", {
                                src: aboutData.value.companyImage || _unref(aboutImg),
                                alt: "公司图片"
                            }, null, 8, _hoisted_6)
                        ])
                    ])
                ]),
                _createElementVNode("section", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "icon" }, [
                                _createElementVNode("img", {
                                    src: _imports_0,
                                    alt: "经验图标"
                                })
                            ], -1)),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("span", _hoisted_12, _toDisplayString(aboutData.value.developmentYears || 0), 1),
                                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "unit" }, "年", -1))
                                ]),
                                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "label" }, "发展经验", -1))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "icon" }, [
                                _createElementVNode("img", {
                                    src: _imports_1,
                                    alt: "客户图标"
                                })
                            ], -1)),
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("span", _hoisted_16, _toDisplayString(aboutData.value.customerCount || 0), 1),
                                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "unit" }, "多家", -1))
                                ]),
                                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "label" }, "合作客户", -1))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "icon" }, [
                                _createElementVNode("img", {
                                    src: _imports_2,
                                    alt: "团队图标"
                                })
                            ], -1)),
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("span", _hoisted_20, _toDisplayString(aboutData.value.teamMemberCount || 0), 1),
                                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "unit" }, "多名", -1))
                                ]),
                                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "label" }, "团队成员", -1))
                            ])
                        ])
                    ])
                ]),
                _createVNode(post, {
                    ref_key: "postRef",
                    ref: postRef,
                    onSaved: refreshData
                }, null, 512)
            ]));
        };
    }
});
